import Vue from 'vue';
import Vuex, {StoreOptions} from 'vuex';
import {RootState} from '@/store/types';
import {requestState} from '@/store/requeststate';

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  modules: {
    requestState,
  },
};

export default new Vuex.Store<RootState>(store);
